import angular from 'angular'

angular.module('nominas.nomina')
  .service('NominasNominaCalculoScript', NominasNominaCalculoScript)

function NominasNominaCalculoScript($http) {
  this.get = _get

  function _get() {
    return $http.get('/kendu/nominas/nomina/calculo/script')
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina/Calculo/Script.js